import { MailType, PermissionType, StaffType } from 'types/staff'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { db } from 'firebase/index'
import { toggleMailsAction } from 'reducks/auth/actions'
import { openStaffModalAction } from 'reducks/modal/actions'

const toggleMails = ({
  mails,
  permission,
  staff,
  uid,
}: {
  mails: MailType[]
  permission: PermissionType
  staff?: StaffType
  uid: string
}) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const isEventStaff = getState().auth.is_event_staff
    const manufacturerRef = getState().auth.manufacturer_ref
    const storeRef = getState().auth.store_ref

    const index = mails.findIndex((mail) => {
      if (
        // SSスタッフの場合
        isEventStaff &&
        typeof manufacturerRef === 'undefined'
      ) {
        return mail.store_ref.id === storeRef.id && typeof mail.manufacturer_ref === 'undefined'
      } else if (
        // SSモードの場合
        typeof manufacturerRef !== 'undefined'
      ) {
        return (
          mail.store_ref.id === storeRef.id &&
          typeof mail.manufacturer_ref !== 'undefined' &&
          mail.manufacturer_ref.id === manufacturerRef.id
        )
      } else {
        // 通常店舗の場合
        return mail.store_ref.id === storeRef.id
      }
    })

    if (!mails[index].manufacturer_ref) {
      mails[index] = {
        store_ref: mails[index].store_ref,
        permissions: mails[index].permissions.includes(permission)
          ? mails[index].permissions.filter((prevState) => prevState !== permission)
          : [...mails[index].permissions, permission],
      }
    } else {
      mails[index] = {
        store_ref: mails[index].store_ref,
        manufacturer_ref: mails[index].manufacturer_ref,
        permissions: mails[index].permissions.includes(permission)
          ? mails[index].permissions.filter((prevState) => prevState !== permission)
          : [...mails[index].permissions, permission],
      }
    }

    await db.collection('staffs').doc(uid).update({ mails: mails })
    dispatch(toggleMailsAction(mails))
    // メンバー管理モーダルから変更した際にreducksのstateを反映する
    if (staff) {
      staff.mails = mails
      dispatch(openStaffModalAction(staff))
    }
  }
}

export default toggleMails
